import { pick } from 'lodash'
import { track } from './analytics'

export const agreementSigned = args => {
  track(
    'Agreement Signed',
    pick(args, [
      'workspaceId',
      'workspaceSlug',
      'agreementId',
      'agreementName',
      'agreementVersion',
      'userId',
      'userName'
    ])
  )
}

export const agreementDownloadedUnsignedCopy = args => {
  track(
    'Agreement Downloaded Unsigned Copy',
    pick(args, [
      'workspaceId',
      'workspaceSlug',
      'agreementId',
      'agreementName',
      'agreementVersion',
      'userId',
      'userName'
    ])
  )
}

export const agreementDownloadedSignedCopy = args => {
  track(
    'Agreement Downloaded Signed Copy',
    pick(args, [
      'workspaceId',
      'workspaceSlug',
      'agreementId',
      'agreementName',
      'agreementVersion',
      'userId',
      'userName'
    ])
  )
}
